import App from './App.vue';

export default {
  path: '/CDS_VF_LifelineElectricityDetail',
  name: 'CDS_VF_LifelineElectricityDetail',
  component: App,
  meta: {
    pageProperty: {
      title: 'ライフライン(停電情報)',
      controller: 'CDS_CTR_LifelineElectricityDetail',
    },
  },
};
